'use client';

import { Section } from '@/components/section/section';
import { notifyError } from '@av/bugsnag';
import { ArrowLeftToLine } from 'lucide-react';
import Link from 'next/link';
import { useEffect } from 'react';

export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    notifyError(error);
  }, [error]);

  return (
    <Section>
      <div className="m-auto flex flex-col items-center justify-center py-20">
        <h2 className="mb-4 max-w-sm text-center text-2xl font-medium">
          Er is een onverwachte fout opgetreden bij dit artikel
        </h2>
        <p className="mb-4 max-w-72 text-center text-gray-500">
          Wij zijn op de hoogte gesteld en zullen dit z.s.m. oplossen.
        </p>
        <Link href="/assortiment" className="flex items-center text-center hover:underline">
          <ArrowLeftToLine className="mr-2" /> Terug naar assortiment
        </Link>
      </div>
    </Section>
  );
}
